const x = {
  /** 0px */
  none: 0,
  /** 2px */
  xxs: 0.25,
  /** 4px */
  xs: 0.5,
  /** 6px */
  sm: 0.75,
  /** 8px */
  md: 1,
  /** 12px */
  lg: 1.5,
  /** 16px */
  xl: 2,
  /** 20px */
  "2xl": 2.5,
  /** 24px */
  "3xl": 3,
  /** 32px */
  "4xl": 4,
  /** 40px */
  "5xl": 5,
  /** 48px */
  "6xl": 6,
  /** 64px */
  "7xl": 8,
  /** 80px */
  "8xl": 10,
  /** 96px */
  "9xl": 12,
  /** 128px */
  "10xl": 16,
  /** 160px */
  "11xl": 20
};
export {
  x as s
};
